import { useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { Link, useParams, useNavigate } from "react-router-dom";
import styles from "../../../layout/admin/Main.module.scss";
//共通コンポーネント
import Form from "../../../ui/Form";
import TextField from "../../../ui/TextField";
import PostcodeTextField from "../../../ui/PostcodeTextField";
import TextAreaField from "../../../ui/TextAreaField";
import DateField from "../../../ui/DateField";
import Button from "../../../ui/Button";
import RadioGroup from "../../../ui/RadioGroup";
import Select from "../../../ui/Select";
import SubScreenTitle from "../../../layout/admin/SubScreenTitle";
import ScreenTitle from "../../../layout/admin/ScreenTitle";
import Completion from "./Completion";
import Annotation from "../../../ui/Annotation";
import Explanation from "../../../layout/admin/Explanation";
//API
import { getCodeMasterList } from "../../../../services/apiCodeMaster";
import {
  GetStudentDetail,
  postApprovalStudent,
} from "../../../../services/apiStudent";
//バリデーション
import {
  validateMaxlength,
  validateRequired,
  validateNonNegInt,
  validateEmailAddress,
  validateMinlength,
  validateConfirm,
  validatePostcode,
  validateDifferentVal,
  validateHalfAlphaNum,
  validateGenerationId,
} from "../../../../utils/validate";

const codeApproval = "CD002";
const codeStudentType = "CD009";

const approvalStatusUnApporoval = 0; //承認ステータス_未承認
const approvalStatusApporoval = 1; //承認ステータス_承認済み
const approvalStatusRejected = 2; //承認ステータス_却下

const StudentApproval = () => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();

  // スクロールを一番上に移動
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  };

  //ユーザーID
  const { userId } = useParams();
  // 完了フラグ
  const [isCompFlg, setIsCompFlg] = useState(false);
  // 区分データ
  const [codeApprovalElement, SetCodeApprovalElement] = useState([]);
  const [codeStudentTypeElement, SetCodeStudentTypeElement] = useState([]);
  const navigate = useNavigate();
  const pagetop = useRef();

  //ラジオボタン選択値
  const [selectedStudentType, setSelectedStudentType] = useState();
  const [selectedApproval, setSelectedApproval] = useState(
    approvalStatusUnApporoval
  );
  // 年齢再計算
  const [birth_day, setBirthDay] = useState();
  const [isAgeUnder55, setAgeIsUnder55] = useState();
  //住所が渋谷区外か
  const [isOutOfShibuya, SetisOutOfShibuya] = useState();

  //再計算処理
  useEffect(() => {
    const isDate = (d) => !isNaN(new Date(d).getTime());
    if (!birth_day || !isDate(birth_day)) {
      setValue("age", "--歳");
      setAgeIsUnder55(false);
      return;
    }
    const birthday = new Date(birth_day);
    const today = new Date();
    let age = today.getFullYear() - birthday.getFullYear();

    //年度末年齢計算
    if (birthday.getMonth() + 1 < 4) {
      age += 1;
    }
    if (today.getMonth() + 1 < 4) {
      age -= 1;
    }

    setValue("age", age + "歳");
    setAgeIsUnder55(age < 55);
  }, [birth_day]);

  const checkStreetName = (value) => {
    const DistrictName = String(value).substring(0, 3);
    if (DistrictName === "渋谷区") {
      SetisOutOfShibuya(false);
    } else {
      SetisOutOfShibuya(true);
    }
  };

  useEffect(() => {
    (async function () {
      //区分値を設定
      const approvalData = await getCodeMasterList({ code: codeApproval });
      const studentTypeData = await getCodeMasterList({
        code: codeStudentType,
      });

      SetCodeApprovalElement(
        approvalData.map((d) => {
          return {
            label: d.d_text,
            value: d.d_value,
          };
        })
      );
      SetCodeStudentTypeElement(
        studentTypeData.map((d) => {
          return {
            label: d.d_text,
            value: d.d_value,
          };
        })
      );

      const userData = await GetStudentDetail(userId);

      //不正IDの場合、404として扱う
      //>>学生が取得できないOR承認済み
      if (
        Object.keys(userData).length === 0 ||
        userData?.approval_status === approvalStatusApporoval
      ) {
        navigate("/admin/404");
        return;
      }
      setValue("updated_at", userData.updated_at);
      setValue("name", userData.name);
      setValue("name_kana", userData.name_kana);
      setValue("postcode", userData.postcode);
      setValue("pref", userData.pref);
      setValue("street_name1", userData.street_name1);
      checkStreetName(userData.street_name1);
      setValue("street_name2", userData.street_name2);
      setValue("address", userData.address);
      setValue("street_name3", userData.street_name3);
      setValue("birthday", userData.birthday);
      setBirthDay(userData.birthday);
      setValue("gender", userData.gender);
      setValue("phone_1", userData.phone_1);
      setValue("mail_1", userData.mail_1);
      setValue("mail_1_check", userData.mail_1);
      setValue("phone_2", userData.phone_2);
      setValue("mail_2", userData.mail_2);
      setValue("mail_2_check", userData.mail_2);
      setValue("emergency_name", userData.emergency_name);
      setValue("emergency_emereletion", userData.emergency_emereletion);
      setValue("emergency_phone", userData.emergency_phone);
      setValue("filing_date", userData.filing_date);
      setValue("student_type", userData.student_type);
      setSelectedStudentType(userData.student_type);
      setValue("approval_status", userData.approval_status);
      setSelectedApproval(userData.approval_status);
      setValue("remarks", userData.remarks);
    })();
  }, []);

  //submit
  const onSubmit = (data) => {
    postApprovalStudent(userId, data);
    setIsCompFlg(true);
    scrollTop();
  };

  return (
    <>
      {isCompFlg ? (
        <>
          {selectedApproval === approvalStatusApporoval ? (
            <Completion
              subtitle="学生承認完了"
              explanation="学生の承認が完了いたしました。"
              link={"/admin/student"}
              btntext="一覧へ戻る"
            ></Completion>
          ) : (
            <></>
          )}
          {selectedApproval === approvalStatusRejected ? (
            <Completion
              subtitle="学生却下完了"
              explanation="学生の却下が完了いたしました。"
              link={"/admin/student"}
              btntext="一覧へ戻る"
            ></Completion>
          ) : (
            <></>
          )}
        </>
      ) : (
        <div className={styles.main} ref={pagetop}>
          <ScreenTitle>学生管理</ScreenTitle>
          <Form onSubmitHandler={handleSubmit(onSubmit)}>
            <SubScreenTitle>学生承認</SubScreenTitle>
            <table className={styles.input_form_table}>
              <tbody>
                <tr>
                  <td>
                    <TextField
                      type="hidden"
                      name="updated_at"
                      errors={errors}
                      register={register}
                    ></TextField>
                  </td>
                </tr>
                <tr>
                  <td>
                    <TextField
                      register={register}
                      validation={{
                        ...validateRequired(),
                        ...validateMaxlength(30),
                      }}
                      name="name"
                      errors={errors}
                      label="氏名"
                      placeholder="氏名"
                      required={true}
                    ></TextField>
                  </td>
                </tr>
                <tr>
                  <td>
                    <TextField
                      register={register}
                      validation={{
                        ...validateMaxlength(30),
                      }}
                      name="name_kana"
                      errors={errors}
                      label="フリガナ"
                      placeholder="フリガナ"
                    ></TextField>
                  </td>
                </tr>
                <tr>
                  <td>
                    <PostcodeTextField
                      register={register}
                      validation={{
                        ...validatePostcode(),
                      }}
                      name="postcode"
                      errors={errors}
                      setValue={setValue}
                      addressField="street_name1"
                      label="郵便番号"
                      placeholder="郵便番号"
                    ></PostcodeTextField>
                  </td>
                </tr>
                <tr>
                  <td>
                    <TextField
                      register={register}
                      name="pref"
                      errors={errors}
                      label="都道府県"
                      isStatic={true}
                    ></TextField>
                  </td>
                </tr>
                <tr>
                  <td>
                    <TextField
                      onChange={(e) => checkStreetName(e.target.value)}
                      register={register}
                      validation={{
                        ...validateRequired(),
                        ...validateMaxlength(30),
                      }}
                      name="street_name1"
                      errors={errors}
                      label="町名"
                      placeholder="町名"
                      required={true}
                    ></TextField>
                  </td>
                </tr>
                <tr>
                  <td>
                    <TextField
                      register={register}
                      validation={{
                        ...validateMaxlength(30),
                      }}
                      name="street_name2"
                      errors={errors}
                      label="丁名"
                      placeholder="丁名"
                    ></TextField>
                  </td>
                </tr>
                <tr>
                  <td>
                    <TextField
                      register={register}
                      validation={{
                        ...validateRequired(),
                        ...validateMaxlength(30),
                      }}
                      name="address"
                      errors={errors}
                      label="番地・号"
                      placeholder="番地・号"
                      required={true}
                    ></TextField>
                  </td>
                </tr>
                <tr>
                  <td>
                    <TextField
                      register={register}
                      validation={{
                        ...validateMaxlength(60),
                      }}
                      name="street_name3"
                      errors={errors}
                      label="方書き"
                      placeholder="方書き"
                    ></TextField>
                  </td>
                </tr>
                <tr>
                  <td>
                    <DateField
                      onChange={(event) => setBirthDay(event.target.value)}
                      type="date"
                      register={register}
                      validation={{
                        ...validateRequired(),
                      }}
                      name="birthday"
                      errors={errors}
                      label="生年月日"
                      placeholder="生年月日"
                      watch={watch}
                      required={true}
                    ></DateField>
                  </td>
                </tr>
                <tr>
                  <td>
                    <TextField
                      register={register}
                      name="age"
                      errors={errors}
                      label="年齢(年度末時点)"
                      placeholder="年齢(年度末時点)"
                      isStatic={true}
                    ></TextField>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Select
                      register={register}
                      validation={{}}
                      label="性別"
                      name="gender"
                      errors={errors}
                      options={[
                        { text: "男", value: "男" },
                        { text: "女", value: "女" },
                      ]}
                      watch={watch}
                      defalut={{ text: "---選択していません---", value: "" }}
                      isSetdefalut={true}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <TextField
                      register={register}
                      validation={{
                        ...validateRequired(),
                        ...validateMaxlength(20),
                      }}
                      name="phone_1"
                      errors={errors}
                      label="電話番号1"
                      placeholder="電話番号1"
                      required={true}
                    ></TextField>
                  </td>
                </tr>
                <tr>
                  <td>
                    <TextField
                      register={register}
                      validation={{
                        ...validateMaxlength(100),
                        ...validateEmailAddress(),
                      }}
                      name="mail_1"
                      errors={errors}
                      label="メールアドレス1"
                      placeholder="メールアドレス1"
                    ></TextField>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Annotation>{"(確認用)"}</Annotation>
                    <TextField
                      register={register}
                      validation={{
                        ...validateConfirm(
                          "mail_1",
                          "mail_1_check",
                          "メールアドレス"
                        ),
                      }}
                      name="mail_1_check"
                      errors={errors}
                      placeholder="メールアドレス1"
                    ></TextField>
                  </td>
                </tr>
                <tr>
                  <td>
                    <TextField
                      register={register}
                      validation={{
                        ...validateMaxlength(20),
                        ...validateDifferentVal(
                          "phone_1",
                          "phone_2",
                          "電話番号1と2"
                        ),
                      }}
                      name="phone_2"
                      errors={errors}
                      label="電話番号2"
                      placeholder="電話番号2"
                    ></TextField>
                  </td>
                </tr>
                <tr>
                  <td>
                    <TextField
                      register={register}
                      validation={{
                        ...validateMaxlength(100),
                        ...validateEmailAddress(),
                        ...validateDifferentVal(
                          "mail_1",
                          "mail_2",
                          "メールアドレス1と2"
                        ),
                      }}
                      name="mail_2"
                      errors={errors}
                      label="メールアドレス2"
                      placeholder="メールアドレス2"
                    ></TextField>
                  </td>
                </tr>
                <tr>
                  <td>
                    <Annotation>{"(確認用)"}</Annotation>
                    <TextField
                      register={register}
                      validation={{
                        ...validateConfirm(
                          "mail_2",
                          "mail_2_check",
                          "メールアドレス"
                        ),
                      }}
                      name="mail_2_check"
                      errors={errors}
                      placeholder="メールアドレス2"
                    ></TextField>
                  </td>
                </tr>
                <tr>
                  <td>
                    <TextField
                      register={register}
                      validation={{
                        ...validateMaxlength(30),
                      }}
                      name="emergency_name"
                      errors={errors}
                      label="緊急連絡先(氏名)"
                      placeholder="緊急連絡先(氏名)"
                    ></TextField>
                  </td>
                </tr>
                <tr>
                  <td>
                    <TextField
                      register={register}
                      validation={{
                        ...validateMaxlength(30),
                      }}
                      name="emergency_emereletion"
                      errors={errors}
                      label="緊急連絡先(続柄)"
                      placeholder="緊急連絡先(続柄)"
                    ></TextField>
                  </td>
                </tr>
                <tr>
                  <td>
                    <TextField
                      register={register}
                      validation={{
                        ...validateMaxlength(20),
                      }}
                      name="emergency_phone"
                      errors={errors}
                      label="緊急連絡先(電話番号)"
                      placeholder="緊急連絡先(電話番号)"
                    ></TextField>
                  </td>
                </tr>
                <tr>
                  <td>
                    <DateField
                      type="date"
                      register={register}
                      validation={{
                        ...validateRequired(),
                      }}
                      name="filing_date"
                      errors={errors}
                      label="提出日"
                      placeholder="提出日"
                      required={true}
                      watch={watch}
                    ></DateField>
                  </td>
                </tr>
                <tr>
                  <td>
                    <RadioGroup
                      name="student_type"
                      register={register}
                      errors={errors}
                      label="学生区分"
                      elements={codeStudentTypeElement}
                      watch={watch}
                      selectedValue={selectedStudentType}
                      setSelectedValue={setSelectedStudentType}
                    />
                  </td>
                </tr>
                {isAgeUnder55 ? (
                  <tr>
                    <td>
                      <Explanation is_caution={true}>
                        ！年齢が55歳未満です。
                      </Explanation>
                    </td>
                  </tr>
                ) : (
                  <></>
                )}
                {isOutOfShibuya ? (
                  <tr>
                    <td>
                      <Explanation is_caution={true}>
                        ！渋谷区外にお住まいの方です。
                      </Explanation>
                    </td>
                  </tr>
                ) : (
                  <></>
                )}
                <tr>
                  <td>
                    <div className={styles.buttonbox__left}>
                      <Link
                        to={"/admin/student/duplicate/" + userId}
                        target="_blank"
                        rel="noreferrer noopener"
                      >
                        <Button styleType="search">重複チェック</Button>
                      </Link>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <RadioGroup
                      errors={errors}
                      register={register}
                      label="承認状態"
                      name="approval_status"
                      elements={codeApprovalElement}
                      watch={watch}
                      selectedValue={selectedApproval}
                      setSelectedValue={setSelectedApproval}
                    />
                  </td>
                </tr>
                {selectedApproval === approvalStatusApporoval ? (
                  //「承認」選択時
                  <>
                    <tr>
                      <td>
                        <Annotation>
                          {"例:2021年4月入学の場合「2104」"}
                        </Annotation>
                        <TextField
                          register={register}
                          validation={{
                            ...validateRequired(),
                            ...validateGenerationId(),
                          }}
                          name="generation_id"
                          errors={errors}
                          label="入学年月"
                          placeholder="入学年月"
                          required={true}
                        ></TextField>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <TextField
                          register={register}
                          validation={{
                            ...validateRequired(),
                            ...validateHalfAlphaNum(),
                            ...validateMaxlength(12),
                            ...validateMinlength(8),
                          }}
                          name="password"
                          errors={errors}
                          type="password"
                          label="パスワード"
                          placeholder="パスワード"
                          required={true}
                        ></TextField>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Annotation>{"(確認用)"}</Annotation>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <TextField
                          register={register}
                          validation={{
                            ...validateConfirm(
                              "password",
                              "password_check",
                              "パスワード"
                            ),
                          }}
                          name="password_check"
                          type="password"
                          errors={errors}
                          placeholder="パスワード(確認用)"
                        ></TextField>
                      </td>
                    </tr>
                  </>
                ) : (
                  ""
                )}
                {selectedApproval === approvalStatusRejected ? (
                  <tr>
                    <td>
                      <TextAreaField
                        errors={errors}
                        register={register}
                        validation={{
                          ...validateMaxlength(500),
                          ...validateRequired(),
                        }}
                        label="備考"
                        name="remarks"
                        placeholder="備考"
                        required={true}
                      />
                    </td>
                  </tr>
                ) : (
                  <></>
                )}
              </tbody>
            </table>
            <div className={styles.buttonbox}>
              {selectedApproval === approvalStatusApporoval ? (
                <Button type="submit" styleType="new">
                  承認する
                </Button>
              ) : (
                <></>
              )}
              {selectedApproval === approvalStatusRejected ? (
                <Button type="submit" styleType="new">
                  却下する
                </Button>
              ) : (
                <></>
              )}
            </div>
            <div className={styles.buttonbox}>
              <Link className={styles.link} to="/admin/student">
                学生管理へ戻る
              </Link>
            </div>
            <div className={styles.buttonbox}>
              <Link className={styles.link} to="/admin/top">
                トップページへ戻る
              </Link>
            </div>
          </Form>
        </div>
      )}
    </>
  );
};
export default StudentApproval;
